// The endpoint catalog now lives in @currencycore/shared (shared with the MCP
// server) so the two never drift. Only getApiVersions stays here — it reads
// Vite's import.meta.env, which is dashboard-specific.
export {
  ENDPOINTS,
  getEndpoint,
  buildPath,
  latestVersion,
} from "@currencycore/shared";
export type {
  CatalogEndpoint,
  CatalogParam,
  CatalogResponseField,
  EndpointId,
  ParamLocation,
  ParamType,
} from "@currencycore/shared";

/**
 * Supported API versions, from `VITE_API_VERSIONS` (comma-separated, ascending,
 * e.g. "v1,v2"). Defaults to "v1" when unset. Parsed, trimmed, and deduped.
 */
export function getApiVersions(): string[] {
  const raw = (import.meta.env["VITE_API_VERSIONS"] as string | undefined) ?? "v1";
  const seen = new Set<string>();
  const out: string[] = [];
  for (const part of raw.split(",")) {
    const v = part.trim();
    if (v && !seen.has(v)) {
      seen.add(v);
      out.push(v);
    }
  }
  return out.length > 0 ? out : ["v1"];
}
